import classNames from "components/ui/classNames";
import { RadioGroup, RadioGroupItem } from "components/ui/RadioGroup";
import { DollarSignIcon, PercentIcon } from "lucide-react";

export enum DisplayFormat {
  Percent = "PERCENT",
  Financial = "FINANCIAL",
}

interface DisplayFormatSelectorProps {
  value: DisplayFormat;
  disabled?: boolean;
  onChange: (displayFormat: DisplayFormat) => void;
}
export default function DisplayFormatSelector({ value, disabled, onChange }: DisplayFormatSelectorProps) {
  return (
    <RadioGroup
      loop={false}
      className={classNames(
        "grid h-10 w-full grid-cols-2 items-center justify-between rounded-xl border border-slate-200 bg-slate-50/60 p-1",
        "sm:flex sm:w-auto sm:max-w-24 sm:justify-normal sm:space-x-2",
        "dark:border-slate-950 dark:bg-slate-700 dark:text-slate-300",
      )}
      orientation="horizontal"
      value={value}
      onValueChange={(value) => onChange(value as DisplayFormat)}
    >
      <RadioGroupItem
        key={DisplayFormat.Financial}
        value={DisplayFormat.Financial}
        disabled={disabled}
        className={classNames(
          "h-8 w-full items-center justify-center rounded-xl p-1 text-center sm:w-10",
          "border border-transparent text-sm font-medium tracking-wide text-slate-500 data-[state=checked]:border-teal-800/30",
          "data-[state=checked]:bg-teal-50 data-[state=checked]:font-bold data-[state=checked]:text-teal-600",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-100 focus-visible:ring-offset-1 focus-visible:ring-offset-gray-300",
          "data-[state=checked]:focus-visible:rounded-xl data-[state=checked]:focus-visible:bg-gray-50 data-[state=checked]:focus-visible:text-gray-600",
          "dark:data-[state=checked]:border-teal-950 dark:data-[state=checked]:bg-teal-900/30 dark:data-[state=checked]:text-teal-100",
        )}
      >
        <DollarSignIcon />
      </RadioGroupItem>
      <RadioGroupItem
        key={DisplayFormat.Percent}
        value={DisplayFormat.Percent}
        disabled={disabled}
        className={classNames(
          "h-8 w-full items-center justify-center rounded-xl p-1 text-center sm:w-10",
          "border border-transparent text-sm font-medium tracking-wide text-slate-500 data-[state=checked]:border-teal-800/30",
          "data-[state=checked]:bg-teal-50 data-[state=checked]:font-bold data-[state=checked]:text-teal-600",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-100 focus-visible:ring-offset-1 focus-visible:ring-offset-gray-300",
          "data-[state=checked]:focus-visible:rounded-xl data-[state=checked]:focus-visible:bg-gray-50 data-[state=checked]:focus-visible:text-gray-600",
          "dark:data-[state=checked]:border-teal-950 dark:data-[state=checked]:bg-teal-900/30 dark:data-[state=checked]:text-teal-100",
        )}
      >
        <PercentIcon />
      </RadioGroupItem>
    </RadioGroup>
  );
}
